import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import { HelpAction, HelpLink } from './types';

/** A plain list of links -- "Other topics", "More in ...", "Do it yourself". */
export default function LinkList({ links }: { links: (HelpLink | HelpAction)[] }) {
  const { buildUrl } = useUrlGenerator();

  return (
    <ul className="m-0 list-none p-0 text-sm">
      {links.map((link) => {
        const label = 'title' in link ? link.title : link.label;

        return (
          <li
            key={link.href}
            className="m-0 border-0 border-t border-solid border-slate-200 py-4 first:border-t-0 first:pt-0"
          >
            <a href={buildUrl(link.href)} className="font-semibold text-primary no-underline hover:underline">
              {label}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
